import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-gb-sct",
  "use": "icon-icon-gb-sct-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-gb-sct\">\n  <path fill=\"#0065bd\" d=\"M0 0h512v512H0z\" />\n  <path stroke=\"#fff\" stroke-width=\".6\" d=\"m0 0 5 3M0 3l5-3\" transform=\"scale(102.4 170.66667)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol